













import { Component, Prop, Vue } from 'vue-property-decorator'
import TeamMember from '@/models/TeamMember'

@Component
export default class Team extends Vue {
  @Prop() private team!: TeamMember[]

  // data
  headline: string = 'Team'
}
